export default __webpack_public_path__ + "media/images/logo-contrast-f44603ef8d2832f644fade4c1d3a2806.png";